import {makeStyles} from "@fluentui/react-components";
import React, {useEffect, useState} from "react";
import {AlertFilled} from "@fluentui/react-icons";
import {useUserStore} from "../../../../../stores/useUserStore";
import InquiryDialog from "./InquryDialog";
import AlertDialog from "./AlertDialog";

const useStyles = makeStyles({
    titleBarRoot: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: 'white',
        color: 'black',
        padding: '17px',
        zIndex: 30,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    titleBarContent: {
        fontSize: 'medium',
        fontWeight: 700,
        fontFamily: 'GangwonEduPowerExtraBoldA'
    },
    alertBtn: {
        cursor: 'pointer',
        position: 'absolute',
        right: '5%',
    }
})

export default function TitleBar({title}:{title:string})  {
    const styles = useStyles()
    const { userId, shoppingPathJointId } = useUserStore()

    const [isDialogOpen, setIsDialogOpen] = useState(false)
    const [isAlertDialogOpen, setIsAlertDialogOpen] = useState(false)
    const [isSubmit, setIsSubmit] = useState(false)

    const closeDialog = () => setIsDialogOpen(false)
    const openDialog = () => setIsDialogOpen(true)
    const closeAlertDialog = () => setIsAlertDialogOpen(false)
    const openAlertDialog = () => setIsAlertDialogOpen(true)

    useEffect(() => {
        if (isSubmit) {
            setIsSubmit(false)
        }
    }, [isSubmit])

    return (
        <div className={styles.titleBarRoot}>
            <div className={styles.titleBarContent}>
                {title}
            </div>
            {
                userId && shoppingPathJointId && (
                    <>
                        <div onClick={openDialog} className={styles.alertBtn}>
                        <AlertFilled
                            fontSize={'x-large'}
                        />
                        </div>
                        <InquiryDialog
                            isOpen={isDialogOpen}
                            onClose={closeDialog}
                            setIsSubmit={() => setIsSubmit(true)}
                            userId={userId}
                            shoppingPathJointId={shoppingPathJointId}
                        />
                    </>
                )
            }
            <AlertDialog
                title={'완료'}
                description={'문의 사항 제출되었습니다.'}
                isOpen={isAlertDialogOpen}
                onClose={closeAlertDialog}
            />
        </div>
    );
}